import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../services/user-service';
import { InsightsService } from '../../services/insights-service';

@Injectable({
  providedIn: 'root',
})
export class InsightsDomainGuard  {
  constructor(private router: Router, private userService: UserService, private insightsService: InsightsService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.insightsService.isInsightsDomain()) {
      this.router.navigate(['']);
      return false;
    }
    if (!this.userService.hasInsightsAccess()) {
      this.router.navigate(['/request-access']);
      return false;
    }
    return true;
  }
}
